import React from "react";
import styles from "../Business/Business.module.scss";
import { Link } from "react-router-dom";
import { useConfig } from './../../../app/configcontext';
import { useDispatch } from 'react-redux'
import { businessSlice } from "../../../features/business/businessSlice";
import ProtectedPaymentRoute from "../../auth/Auth";


export default function Business() {
  ProtectedPaymentRoute()
  const config = useConfig();
  const businessTypes = config?.businessType;
  console.log("Business types: ", businessTypes)
  const actions = businessSlice?.actions
  // console.log("Business actions: ", actions)
  const dispatch = useDispatch()
  return (
    <div>
      <section className={styles.business}>
        <div className="container">
          <div className={styles.heading}>
            <h2>Create your business in minutes </h2>
          </div>
          <div className={styles.typ_wrp}>
            {businessTypes && businessTypes.map((ele) => {
              return (
                <>
                  <div className={styles.typ_box} key={ele.id}>
                    <h4>{ele.name}</h4>
                    <p>{ele.description}</p>
                    <Link to={ele.code} onClick={() => dispatch(actions.update_business_id(ele.id))}>Register {ele.code}</Link>
                  </div>
                </>
              ); 
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
